import { buildBarModel } from './profile-completion-sections'

function isComplete(percent) {
  return percent === 100
}

export default function syncProfileCompletion({
  school,
  previousSchool,
  updateSchoolBadge,
  options = {},
}) {
  if (!school || typeof updateSchoolBadge !== 'function') {
    return Promise.resolve()
  }

  const nextPercent = buildBarModel(school, options).percent
  const previousPercent = previousSchool
    ? buildBarModel(previousSchool, options).percent
    : nextPercent
  const didCompletionStateChange =
    isComplete(previousPercent) !== isComplete(nextPercent)

  if (!didCompletionStateChange) return Promise.resolve()

  return Promise.resolve(
    updateSchoolBadge({
      scProfile: isComplete(nextPercent),
    })
  ).catch(() => Promise.resolve())
}
